import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled, { css } from 'styled-components'
import shortid from 'shortid'

import { PATH_OVERVIEW, HEADER } from '../../../project-profit-sheet/constants'

import { getSpreadsheets } from '../selectors'
import ScrollWrapper from '../contexts/ScrollWrapper'

import { valueStyles } from './modifiers'

/**
 * @typedef {import('../model').ValueState} ValueState
 */

const columnLayout = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, 84px);
  grid-auto-columns: 84px;
`

const Root = styled.div`
  height: 100%;
  display: inline-block;
`

const Head = styled.div`
  height: 50px;
  grid-template-rows: repeat(2, 25px);

  ${columnLayout}
`

const Year = styled.div`
  padding-top: 3px;
  padding-left: 16px;

  grid-row: 1;
  grid-column: 1 / -1;
  z-index: 2;

  display: flex;
  align-items: center;

  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  color: #333333;
  font-family: 'Gotham-Medium' !important;
  font-size: 13px;
`

const Month = styled.div`
  padding-top: 3px;

  grid-row: 2;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #ededed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  color: #333333;
  font-family: 'Gotham' !important;
  font-size: 12px;
`

export const Body = styled.div`
  max-height: calc(100% - 50px);
  padding-bottom: 24px;
  background-color: #fff;
  overflow-y: scroll;
`

const Row = styled.div`
  height: 45px;
  border-bottom: 1px solid #ddd;

  ${columnLayout}
`

const Cell = styled(Link)`
  width: 100%;
  height: 100%;
  border-right: 1px solid #ddd;
  cursor: pointer;

  ${valueStyles}

  &:hover {
    background-color: #ededed;
  }
`

/**
 * @typedef {object} Props
 * @property {{
 *   year: string,
 *   months: string[],
 *   projects: { id: string, bymonths: ValueState[] }[]
 * }[]} data
 * @property {(payload: { to: string }) => void} redirect
 */

/** @extends {Component<Props>} */
export class Spreadsheets extends Component {
  render = () => {
    const { data } = this.props

    if (!data || !data.length) return <Root />

    return data.map(({ year, months, projects }) => (
      <Root key={ shortid.generate() }>
        <Head>
          <Year>{year}</Year>
          {months.map(m => (
            <Month key={ shortid.generate() }>{m}</Month>
          ))}
        </Head>
        <ScrollWrapper.Consumer>
          {Wrapper => (
            <Wrapper>
              <Body>
                {projects.map(({ id, bymonths }) => (
                  <Row key={ shortid.generate() }>
                    {bymonths.map((gp, idx) => (
                      <Cell
                        value={ gp }
                        to={ {
                          pathname: `${PATH_OVERVIEW}/${id}`,
                          state: {
                            header: HEADER,
                            id,
                            at: `${year}/${months[idx]}`,
                          },
                        } }
                        key={ shortid.generate() }
                      />
                    ))}
                  </Row>
                ))}
              </Body>
            </Wrapper>
          )}
        </ScrollWrapper.Consumer>
      </Root>
    ))
  }
}

const mapStateToProps = createStructuredSelector({
  data: getSpreadsheets,
})

export default connect(mapStateToProps)(Spreadsheets)



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/components/Spreadsheets.jsx